import React from 'react';
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import UsersInputs from '../../components/UsersInputs/UsersInputs';
import { connect } from 'react-redux';
import {
  createUserRequestAction,
} from '../../store/users/usersActions';
import { useTranslation } from '../../hooks/useTranslation';

const CreateUser = (props) => {
  const {
    createUserRequest,
    isLoading,
    createUserData,
  } = props;

  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleUserSubmit = (userData) => {
    console.log('Submitting new user:', userData);
    
    createUserRequest({
      data: userData,
      navigate: navigate
    });
  };

  const handleBackToUsers = () => {
    navigate('/users');
  };

  return (
    <div>
      <CContainer>
        {/* Breadcrumb */}
        <CBreadcrumb className="mb-4">
          <CBreadcrumbItem 
            href="#/users" 
            onClick={(e) => {
              e.preventDefault();
              handleBackToUsers();
            }}
          >
            {t('users') || 'Kullanıcılar'}
          </CBreadcrumbItem>
          <CBreadcrumbItem active>
            {t('createUser') || 'Kullanıcı Oluştur'}
          </CBreadcrumbItem>
        </CBreadcrumb>

        <CRow>
          <CCol xs={12}>
            <CCard>
              <CCardHeader>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="mb-0">
                    {t('createNewUser') || 'Yeni Kullanıcı Oluştur'}
                  </h4>
                  <small className="text-muted">
                    {t('userInformation') || 'Kullanıcı Bilgileri'}
                  </small>
                </div>
              </CCardHeader>
              <CCardBody>
                <UsersInputs 
                  onSubmit={handleUserSubmit}
                  onCancel={handleBackToUsers}
                  isLoading={isLoading}
                  submitResponse={createUserData}
                  isEdit={false}
                />
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.loadingReducer?.isLoading || false,
    createUserData: state.usersReducer?.createUserData || null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createUserRequest: (payload) => {
      dispatch(createUserRequestAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateUser);